// Stripe simulada (só no modo local, com STRIPE_SIMULADO=1 na API): faz as vezes do Checkout e da página da fatura.
import { useState } from 'react';
import { ir } from '../comum/rotas.ts';
import { Tela, Topo } from './comum.tsx';

export function Simulado({ sessao, fatura }: { sessao: string | null; fatura: string | null }) {
  const [erro, setErro] = useState<string | null>(null);
  const [codigo, setCodigo] = useState('');
  const id = sessao ?? fatura;
  return (
    <Tela>
      <Topo titulo="Stripe simulada" />
      <div className="cartao">
        <p>{sessao ? 'Checkout de teste no cartão.' : 'Fatura Pix de teste.'} Nada é cobrado.</p>
        <p className="nota">{id}</p>
      </div>
      {sessao && (
        <label className="campo">
          <span>Código promocional</span>
          <input value={codigo} autoComplete="off" onChange={(ev) => setCodigo(ev.target.value)} />
        </label>
      )}
      {erro && <p className="erro" role="alert">{erro}</p>}
      <button className="btn1 largo" disabled={!id} onClick={async () => {
        const r = await fetch('/api/dev/simular', {
          method: 'POST', headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ acao: sessao ? 'concluir' : 'pagar', id, ...(sessao && codigo.trim() ? { codigo: codigo.trim() } : {}) }),
        });
        if (r.ok) ir({ tela: 'assinatura-ok', plano: null }, true); else setErro('A API simulada recusou: ' + r.status);
      }}>{sessao ? 'PAGAR NO CARTÃO' : 'PAGAR O PIX'}</button>
      <button className="link" onClick={() => history.back()}>Voltar sem pagar</button>
    </Tela>
  );
}
